
function getError(context, err) {
  if (err.status === 403) {
    return context.$t('message.acesso_negado');
  }
  return err.data && err.data.error ? err.data.error : err;
}

const errorHandler = (context, err, callback, toastType = 'snack', toastTime = 3E3) => {
  const error = getError(context, err);
  context.$toast.create(error, toastType, toastTime);
  if (callback) {
    callback();
  }
};

const acessoNegado = (context, error, callback = () => {}, route) => {
  if (error && error.status !== 403) {
    errorHandler(context, error, callback);
  } else {
    context.$toast.create(context.$t('message.acesso_negado'), 'snack', 3E3);
    context.$router.push({ name: route || 'dashboard' });
    callback();
  }
};

function plugin(Vue) {
  Vue.prototype.$error = errorHandler;
  Vue.prototype.$acessoNegado = acessoNegado;
}

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
  window.Vue.use(plugin); // eslint-disable-line no-undef
}

// module.exports = plugin;
export default plugin;



// WEBPACK FOOTER //
// ./src/common/functions/error-handler.js